/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useRef, useState} from 'react'
import { useLocation } from 'react-router-dom'
import { useThemeMode } from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import { HOME_PAGE_CONTEXT_KEY } from '../../../../../pages/home/provider/HomeRequestProvider'
import { useIntl } from 'react-intl'
type ProjectListHeaderProps = {
  screenType: 'small' | 'large'
  onAddPress?: () => void
  onKeywordChange?: (str: string) => void
  // isTab1Active?: boolean
  isTab2Active?: boolean
  isTab3Active?: boolean
  isTab4Active?: boolean
  isTab5Active?: boolean
}
const ProjectListHeader: FC<ProjectListHeaderProps> = ({
  screenType,
  onAddPress,
  onKeywordChange,
  isTab2Active,
  isTab3Active,
  isTab4Active,
  isTab5Active,
}) => {
  const intl = useIntl()
  const homeContext = localStorage.getItem(HOME_PAGE_CONTEXT_KEY)
  let hpdc: any = {}
  if (homeContext) {
    hpdc = JSON.parse(homeContext)
  }
  const {pathname, hash, search} = useLocation()
  const {mode,styles} = useThemeMode()
  const [Keyword, setKeyword] = useState<string>(hpdc?.Keyword || '')
  let iptRef: any = useRef()
  useEffect(() => {
    console.log('pathname : ', pathname, hash, search)
    if (search?.includes('s=focus')) {
      if (iptRef) {
        setTimeout(() => {
          iptRef?.current?.focus()
        }, 500)

      }
    }
  }, [pathname, search])

  const handleClearClick = () => {
    setKeyword('');
    if (onKeywordChange) {
      onKeywordChange('');
    }
  };
  return (
    <div className={'d-flex flex-row-reverse flex-wrap '} data-bs-theme={mode}>
      <div
        data-bs-theme={mode}
        style={{width: screenType === 'small' ? '100%' : 'auto'}}
        className={`d-flex justify-content-end ${screenType === 'small' ? 'mb-5' : ''}`}
      >
        <button
          className={'btn text-white'}
          style={{backgroundColor:styles.backgroundColor}}
          onClick={onAddPress}
        >
          <div className={'d-flex align-items-center'}>
            <i className='fa fa-add text-white'></i>
            <div className='ms-3'>
              {intl.formatMessage({id: 'NEW_ESTIMATE'})}
            </div>
          </div>
        </button>
      </div>
      <div
        className={`d-flex align-items-center ps-5 pe-5 ${screenType === 'large' ? 'me-5' : ''}`}
        data-bs-theme={mode}
        style={{
          flex: 1,
          //backgroundColor: '#f9f9f9',
          borderRadius: 5,
        }}
      >
        <i className={'fa fa-search'} data-bs-theme={mode} />
        <div style={{position: 'relative', display: 'inline-block'}} className='w-100'>
          <input
            placeholder='Recherche'
            ref={iptRef}
            className='w-100 ms-5 fs-4 form-control '
            data-bs-theme={mode}
            value={Keyword}
            style={{
              outline: 'none',
              border: 'none',
              boxShadow: 'none',
              backgroundColor: mode === 'dark' ? '#151521' : '#ecf0f1'
            }}
            onChange={(e) => {
              setKeyword(e.target.value)
              if (onKeywordChange) {
                onKeywordChange(e.target.value)
              }
            }}
          />
          <i
            className='fa-solid fa-eraser fs-1'
            style={{position: 'absolute', right: '0px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer'}}
             onClick={handleClearClick}
          ></i>
        </div>
      </div>
    </div>
  )
}

export default ProjectListHeader
